var _rect, _circle, _circle2, _circle3, _path, _rect2, _rect3, _rect4, _path2, _path3, _path4, _path5, _rect5, _path6, _path7, _path8, _path9, _circle4, _path10, _path11, _path12, _path13, _path14, _circle5, _circle6, _circle7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobalNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 900,
    viewBox: "0 0 1200 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 900,
    rx: 36,
    fill: "#F5FBFB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 206,
    cy: 174,
    r: 88,
    fill: "#D5F0EC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 988,
    cy: 166,
    r: 108,
    fill: "#E8F3FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 998,
    cy: 730,
    r: 126,
    fill: "#FFF0CB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 658C128 577.366 193.366 512 274 512H908C988.634 512 1054 577.366 1054 658V698C1054 778.634 988.634 844 908 844H274C193.366 844 128 778.634 128 698V658Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 564,
    width: 228,
    height: 94,
    rx: 22,
    fill: "#132238"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 486,
    y: 564,
    width: 228,
    height: 94,
    rx: 22,
    fill: "#0F766E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 778,
    y: 564,
    width: 208,
    height: 94,
    rx: 22,
    fill: "#F59E0B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M276 311C276 269.026 310.026 235 352 235H852C893.974 235 928 269.026 928 311V429C928 470.974 893.974 505 852 505H352C310.026 505 276 470.974 276 429V311Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M342 348H529",
    stroke: "#0F766E",
    strokeWidth: 22,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M342 397H676",
    stroke: "#D8E0EA",
    strokeWidth: 18,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M342 436H605",
    stroke: "#D8E0EA",
    strokeWidth: 18,
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 732,
    y: 311,
    width: 134,
    height: 134,
    rx: 32,
    fill: "#EEF7FB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M778 387L812 351L822 361L789 394H778V387Z",
    fill: "#0F766E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M797 404C833.451 404 863 374.451 863 338C863 301.549 833.451 272 797 272C760.549 272 731 301.549 731 338C731 374.451 760.549 404 797 404Z",
    stroke: "#132238",
    strokeWidth: 12
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M600 235V176",
    stroke: "#0F766E",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M484 176H716",
    stroke: "#0F766E",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 142,
    r: 24,
    fill: "#0F766E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M350 235L266 166",
    stroke: "#132238",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M852 235L934 166",
    stroke: "#132238",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M342 611H274",
    stroke: "white",
    strokeWidth: 16,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M634 611H566",
    stroke: "white",
    strokeWidth: 16,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M904 611H836",
    stroke: "white",
    strokeWidth: 16,
    strokeLinecap: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 611,
    r: 12,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 540,
    cy: 611,
    r: 12,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 810,
    cy: 611,
    r: 12,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalNetwork);
export default __webpack_public_path__ + "static/media/global-network.562626eb924a684916875d2bbf6d6773.svg";
export { ForwardRef as ReactComponent };